<template>
    <PriceSpecificationFlight :product="product" />
</template>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { FlightProduct } from '@/api/Cart/cart.interfaces';
    import PriceSpecificationFlight from '@/components/shared/PriceSpecification/Flight/PriceSpecificationFlight.vue';

    export default defineComponent({
        name: 'FlightModalPrice',
        components: { PriceSpecificationFlight },
        props: {
            product: {
                type: Object as PropType<FlightProduct>,
                required: true,
            },
        },
    });
</script>
